import { VariableValue, VariableStateEnum, VariableState } from '@flexem/fc-gui';
import { Subject, empty } from 'rxjs';
import { VariableDataType } from '../../main/workshop/element-setting/shared/variable/variable-data-type';
import * as _ from 'lodash';
var DefaultSimulateRemoteVariableProtocol = /** @class */ (function () {
    function DefaultSimulateRemoteVariableProtocol(variableValueStore, variables) {
        this.variableValueStore = variableValueStore;
        this.variables = variables;
        this.connected = new Subject();
        this.variableStatesChanged = new Subject();
        this.variableValuesChanged = new Subject();
    }
    DefaultSimulateRemoteVariableProtocol.prototype.subscribeVariableStates = function (variableNames) {
        var _this = this;
        variableNames.forEach(function (variableName) {
            _this.variableStatesChanged.next([new VariableState(variableName, VariableStateEnum.Normal)]);
        });
        return empty();
    };
    DefaultSimulateRemoteVariableProtocol.prototype.unsubscribeVariableStates = function (variableNames) {
        return empty();
    };
    DefaultSimulateRemoteVariableProtocol.prototype.tryOpenVariables = function (variableNames) {
        var _this = this;
        variableNames.forEach(function (variableName) {
            _this.variableValuesChanged.next([_this.getVariableValue(variableName)]);
        });
        return empty();
    };
    DefaultSimulateRemoteVariableProtocol.prototype.tryStopVariables = function () {
        return empty();
    };
    DefaultSimulateRemoteVariableProtocol.prototype.writeVariable = function (variableName, value) {
        var variableValue = new VariableValue(variableName, VariableStateEnum.DataNormal, value);
        this.variableValueStore.set(variableName, variableValue);
        this.variableValuesChanged.next([variableValue]);
        return empty();
    };
    DefaultSimulateRemoteVariableProtocol.prototype.writeVariableWordByBit = function (variableName, index, value) {
        var oldVariableValue = this.getVariableValue(variableName).value;
        var variableValues = this.changeVariableValueToDecimal(oldVariableValue, index, value);
        var variableValue = new VariableValue(variableName, VariableStateEnum.DataNormal, variableValues);
        this.variableValueStore.set(variableName, variableValue);
        this.variableValuesChanged.next([variableValue]);
        return empty();
    };
    DefaultSimulateRemoteVariableProtocol.prototype.getVariableValue = function (variableName) {
        if (!this.variableValueStore.has(variableName)) {
            var hasStringTypeVariable = _.find(this.variables, function (v) {
                return variableName === v.variableName && VariableDataType.String === v.dataType;
            });
            if (hasStringTypeVariable) {
                this.variableValueStore.set(variableName, new VariableValue(variableName, VariableStateEnum.DataNormal, 'Abc'));
            }
            else {
                this.variableValueStore.set(variableName, new VariableValue(variableName, VariableStateEnum.DataNormal, 0));
            }
        }
        return this.variableValueStore.get(variableName);
    };
    DefaultSimulateRemoteVariableProtocol.prototype.changeVariableValueToDecimal = function (oldValue, index, value) {
        oldValue = oldValue.toString();
        var newValue = this.replaceDigitOfBinaryString(this.decimalToBinary(oldValue, 32), 31, index, value);
        return parseInt(newValue, 2);
    };
    DefaultSimulateRemoteVariableProtocol.prototype.replaceDigitOfBinaryString = function (oldValue, maxLength, index, value) {
        var valueToArray = oldValue.split('');
        valueToArray[maxLength - index] = value.toString();
        return valueToArray.join('');
    };
    DefaultSimulateRemoteVariableProtocol.prototype.decimalToBinary = function (num, bits) {
        var resArry = [];
        var xresArry = [];
        var i = 0;
        // 除2取余
        for (; num > 0;) {
            resArry.push(num % 2);
            num = parseInt((num / 2).toString());
            i++;
        }
        // 倒序排列
        for (var j = i - 1; j >= 0; j--) {
            xresArry.push(resArry[j]);
        }
        // 报错
        if (bits < xresArry.length) {
            // console.log('控制位小于转换位数');
        }
        // 补0操作
        if (bits) {
            for (var r = xresArry.length; r < bits; r++) {
                xresArry.unshift('0');
            }
        }
        return xresArry.join().replace(/,/g, '');
    };
    return DefaultSimulateRemoteVariableProtocol;
}());
export { DefaultSimulateRemoteVariableProtocol };
